import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TreePage from './pages/TreePage';
import CategoryPage from './pages/CategoryPage';
import ToolPage from './pages/ToolPage';
import CreatorPage from './pages/CreatorPage';
import CompanyPage from './pages/CompanyPage';
import DiscoverPage, { DiscoverIndex } from './pages/DiscoverPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminAnalytics from './pages/admin/AdminAnalytics';
import AdminAI from './pages/admin/AdminAI';
import AdminToolsList from './pages/admin/AdminToolsList';
import AdminToolEdit from './pages/admin/AdminToolEdit';
import AdminResourceCreate from './pages/admin/AdminResourceCreate';
import AdminImportExport from './pages/admin/AdminImportExport';
import SubmitPage from './pages/SubmitPage';
import SubmitSuccessPage from './pages/SubmitSuccessPage';
import DisclosurePage from './pages/DisclosurePage';
import AlternativesPage from './pages/AlternativesPage';
import ContactPage from './pages/ContactPage';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

function NotFound() {
  return (
    <div className="page-container" data-testid="not-found">
      <h1 className="page-title">Page not found</h1>
      <p className="muted" style={{ marginBottom: 16 }}>
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <a href="/" className="pill-btn primary">Back to home</a>
    </div>
  );
}

function AppShell() {
  const [theme, setTheme] = useState(() => localStorage.getItem('ai_fw_theme') || 'dark');
  const location = useLocation();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('ai_fw_theme', theme);
  }, [theme]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const toggleTheme = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));

  const isTreeHome = location.pathname === '/' || location.pathname === '/tree';

  return (
    <ErrorBoundary>
      {!isTreeHome && <SiteHeader theme={theme} toggleTheme={toggleTheme} />}
      <Routes>
        <Route path="/" element={<TreePage />} />
        <Route path="/tree" element={<TreePage />} />
        <Route path="/browse" element={<HomePage />} />
        <Route path="/category/:slug" element={<CategoryPage />} />
        <Route path="/tool/:slug" element={<ToolPage />} />
        <Route path="/creator/:slug" element={<CreatorPage />} />
        <Route path="/company/:slug" element={<CompanyPage />} />
        <Route path="/discover" element={<DiscoverIndex />} />
        <Route path="/discover/:slug" element={<DiscoverPage />} />
        <Route path="/submit" element={<SubmitPage />} />
        <Route path="/submit/success" element={<SubmitSuccessPage />} />
        <Route path="/disclosure" element={<DisclosurePage />} />
        <Route path="/alternatives/:slug" element={<AlternativesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/analytics" element={<AdminAnalytics />} />
        <Route path="/admin/ai" element={<AdminAI />} />
        <Route path="/admin/tools" element={<AdminToolsList />} />
        <Route path="/admin/tools/:slug/edit" element={<AdminToolEdit />} />
        <Route path="/admin/resources/new" element={<AdminResourceCreate />} />
        <Route path="/admin/import-export" element={<AdminImportExport />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isTreeHome && <SiteFooter />}
    </ErrorBoundary>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Tree is the identity — homepage AND /tree both render it */}
        <Route path="/" element={<TreePage />} />
        <Route path="/tree" element={<TreePage />} />
        <Route path="/*" element={<AppShell />} />
      </Routes>
    </BrowserRouter>
  );
}
